import { Injectable } from "@angular/core";
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { environment } from "../../environments/environment";
import { ApiService } from "./api.service";

@Injectable({
  providedIn: "root",
})
export class FirebaseService {
  private app;
  private messaging;

  constructor(private api: ApiService) {
    this.app = initializeApp(environment.firebase);
    this.messaging = getMessaging(this.app);
  }

  async requestPermission() {
    try {
      const permission = await Notification.requestPermission();
      if (permission === "granted") {
        console.log("Notification permission granted.");
        await this.getToken();
      } else {
        console.log("Unable to get permission to notify.");
      }
    } catch (err) {
      console.log("An error occurred while requesting permission ", err);
    }
  }

  private async getToken() {
    try {
      const currentToken = await getToken(this.messaging, {
        vapidKey:
          "BGBxUXpcis40N9gI4Ayt_3YqUN5jKIE9MwFyBObY2t4hxnIiEcATOfdpqZO_EnFotadkwrUWBPHRecWjo3udioE",
      });

      if (currentToken) {
        console.log("Current token for client: ", currentToken);
        await this.sendTokenToServer(currentToken);
      } else {
        console.log(
          "No registration token available. Request permission to generate one."
        );
      }
    } catch (err) {
      console.log("An error occurred while retrieving token. ", err);
    }
  }

  async sendTokenToServer(token: string) {
    console.log("Sending token to server: ", token);
    try {
      const res = await this.api.post(
        "notification/fcm",
        {
          token: token,
          deviceType: 2,
        },
        true
      );
      console.log("Sent token to server: ", res);
    } catch (err) {
      console.error("Error sending token to server: ", err);
    }
  }

  listenToMessages() {
    onMessage(this.messaging, (payload) => {
      console.log("Message received:", payload);
      // Handle the received message
    });
  }
}
